import { Component, Input } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { NgIf } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [SharedModule, SidebarModule, BadgeModule, NgIf, TooltipModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input() text = '';
  @Input() sub = '';
  @Input() help = '';
  @Input() icon = '';
  @Input() styleClass = '';
  @Input() count?: number;
  @Input() suffix?: string;
  @Input() suffixIcon?: string;
}
